import { trackEvent, getPageSource } from '@mc/track-event'

import { type OutcomeKeyLearnings } from 'libs/server/api/outcomes'

// when user sees the outcome tiles section - at least 30% of the section is visible
export const trackOutcomeTilesViewed = ({
  courseSlug,
  outcomeTitles,
}: {
  courseSlug: string
  outcomeTitles: string[]
}) =>
  trackEvent('Outcomes Module Viewed', {
    class: courseSlug,
    outcome_titles: outcomeTitles,
    page_source: getPageSource(),
  })

// action: 'open' when user clicks on the plus icon to see the key learnings
// action: 'close' when user clicks on the close icon to see the main outcome content
export const trackShowHideKeyLearningsClick = ({
  action,
  courseSlug,
  outcome,
  position,
}: {
  action: 'open' | 'close'
  courseSlug: string
  outcome: OutcomeKeyLearnings
  position: number
}) =>
  trackEvent('Outcomes Module Clicked', {
    class: courseSlug,
    outcome_slug: outcome.slug,
    outcome_title: outcome.title,
    action,
    page_source: getPageSource(),
    page_category: 'class',
    position,
  })
